import currency from "currency.js";

export const formatDollarsFromCents = (cents: number): string =>
  currency(cents, { fromCents: true }).format();
